export class DamageBonus {
  public static calc6th(str: number, siz: number) {
    const val = str + siz;
    if (val <= 12 && val >= 2) {
      return '-1D6';
    } else if (val <= 16 && val >= 13) {
      return '-1D4';
    } else if (val <= 24 && val >= 17) {
      return 'none';
    } else if (val <= 32 && val >= 25) {
      return '1D4';
    } else if (val <= 40 && val >= 33) {
      return '1D6';
    } else if (val <= 56 && val >= 41) {
      return '2D6';
    } else if (val <= 72 && val >= 57) {
      return '3D6';
    } else if (val <= 88 && val >= 73) {
      return '4D6';
    } else {
      return 'none';
    }
  }

  public static calc7th(str: number, siz: number) {
    const val = str + siz;
    if (val <= 64 && val >= 2) {
      return '-2';
    } else if (val <= 84 && val >= 65) {
      return '-1';
    } else if (val <= 124 && val >= 85) {
      return 'none';
    } else if (val <= 164 && val >= 125) {
      return '1D4';
    } else if (val <= 204 && val >= 165) {
      return '1D6';
    } else if (val <= 284 && val >= 205) {
      return '2D6';
    } else if (val <= 364 && val >= 285) {
      return '3D6';
    } else if (val <= 444 && val >= 365) {
      return '4D6';
    } else if (val <= 524 && val >= 445) {
      return '5D6';
    } else {
      return 'none';
    }
  }
}
